"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecureScaleAttendantAuthorization = exports.SecureScaleAttendantAuthority = exports.SECURESCALE_ATTENDANT_MAX_LIFETIME_MS = void 0;
const zod_1 = require("zod");
exports.SECURESCALE_ATTENDANT_MAX_LIFETIME_MS = 96 * 60 * 60 * 1000;
const Id = zod_1.z.string().trim().min(1).max(128);
const Revision = zod_1.z.string().regex(/^(0|[1-9]\d*)$/);
/** Full replacement authority, never a PIN credential or a POS employee-code alias. */
exports.SecureScaleAttendantAuthority = zod_1.z
    .object({
    kind: zod_1.z.literal('securescale-attendant-authorization-v1'),
    issuer: zod_1.z.literal('reform-bos'),
    audience: zod_1.z.literal('securescale-terminal'),
    tenantId: Id,
    storeId: Id,
    terminalId: Id,
    revision: Revision,
    revocationFloor: Revision,
    issuedAt: zod_1.z.string().datetime(),
    expiresAt: zod_1.z.string().datetime(),
    grants: zod_1.z
        .array(zod_1.z
        .object({
        cashierId: Id,
        pinHash: zod_1.z.string().min(1).max(2048).nullable(),
        pinKeyVersion: zod_1.z.number().int().safe().nonnegative(),
        isAttendant: zod_1.z.boolean(),
        status: zod_1.z.enum(['active', 'suspended']),
        permissionCodes: zod_1.z.array(zod_1.z.string().trim().min(1).max(128)).max(512),
    })
        .strict())
        .max(100000),
})
    .strict()
    .superRefine((v, ctx) => {
    const duration = Date.parse(v.expiresAt) - Date.parse(v.issuedAt);
    if (duration <= 0 || duration > exports.SECURESCALE_ATTENDANT_MAX_LIFETIME_MS)
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['expiresAt'],
            message: 'Authority lifetime must be positive and at most 96 hours',
        });
    if (BigInt(v.revocationFloor) > BigInt(v.revision))
        ctx.addIssue({
            code: zod_1.z.ZodIssueCode.custom,
            path: ['revocationFloor'],
            message: 'Floor cannot exceed revision',
        });
    const ids = new Set();
    for (const grant of v.grants) {
        if (ids.has(grant.cashierId))
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                path: ['grants'],
                message: 'Duplicate cashier identity',
            });
        ids.add(grant.cashierId);
        if (new Set(grant.permissionCodes).size !== grant.permissionCodes.length)
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                path: ['grants'],
                message: 'Duplicate permission',
            });
    }
});
/** Signature is Ed25519 over SHA256(canonicalSecureScaleJson({kind,payload,kid})). */
exports.SecureScaleAttendantAuthorization = zod_1.z
    .object({
    kind: zod_1.z.literal('securescale-attendant-signed-v1'),
    payload: exports.SecureScaleAttendantAuthority,
    kid: Id,
    signature: zod_1.z.string().regex(/^[A-Za-z0-9+/]{86}==$/),
})
    .strict();
//# sourceMappingURL=securescale-attendant.js.map